import { Card, IconButton, Stack, Typography } from '@mui/material';
import { MachineDetails } from '../../types/manageAccount.type';
import { EditOutlined } from '@mui/icons-material';

export default function MachineTab({
  selectedMachine,
  setCurrentStep,
}: {
  selectedMachine: MachineDetails | null;
  setCurrentStep: any;
}) {
  return (
    <Card>
      <Stack p={2} borderRadius={2} direction={'row'}>
        <img
          alt="machine"
          style={{ width: '50px', height: '50px' }}
          src={selectedMachine?.prd_image_url}
        />
        <Stack flex={1}>
          <Typography>{selectedMachine?.machine_name}</Typography>
          <Typography variant="caption">{selectedMachine?.machine_type}</Typography>
        </Stack>
        <IconButton onClick={() => setCurrentStep(1)}>
          <EditOutlined sx={{ fontSize: '20px' }} />
        </IconButton>
      </Stack>
    </Card>
  );
}
